import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/api/auth.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ProjectTableDto } from '../entity/projectTableDto';
import { Project } from '../entity/project';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  getProjectsByLicence(licenceId: number): Observable<ProjectTableDto[]> {
    const requestUrl =
      environment.backendUrl + 'api/Project/GetProjectsByLicence/' + licenceId;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<ProjectTableDto[]>(requestUrl, {
      headers: authHeader,
    });
  }

  createProject(project: Project): any {
    const requestUrl = environment.backendUrl + 'api/Project/CreateProject/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post(requestUrl, project, { headers: authHeader });
  }

  updateProject(project: Project): any {
    const requestUrl =
      environment.backendUrl + 'api/Project/editProject/' + project.id;
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.put(requestUrl, project, { headers: authHeader });
  }

  getProjectById(id: number): Observable<Project> {
    const requestUrl =
      environment.backendUrl + 'api/Project/GetProjectById/' + id;
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.get<Project>(requestUrl, { headers: authHeader });
  }
}
